import { fromEventPattern, merge, timer } from "rxjs"
import { debounce } from "rxjs/operators"

function setupDevtoolsEvents(
  context,
  events = ["object:moving", "object:scaling", "object:rotating"]
) {
  const eventStreams = events.map((ev) =>
    fromEventPattern(
      (handler) => context.on(ev, handler),
      (handler) => context.off(ev, handler)
    )
  )

  const allEvents$ = merge(...eventStreams).pipe(debounce(() => timer(1000)))
  const unsubscribe = allEvents$.subscribe((e) => {
    const { scaleY, scaleX, angle, top, left, width, height } = e.target
    const newWidth = width * scaleX
    const newHeight = height * scaleY

    const newCoords = {
      scaleY,
      scaleX,
      left,
      top,
      angle,
      width: newWidth,
      height: newHeight,
    }
    console.log("coords", newCoords)
    navigator.clipboard
      .writeText(JSON.stringify(newCoords))
      .then(() => console.log("copied to clipboard"))
  })

  return unsubscribe
}

export default setupDevtoolsEvents
